import angular from 'angular';
import amplifyInformationComponent from './amplifyInformation.component';

let amplifyInformationModule = angular.module('amplifyInformation', [
])

.component('amplifyInformation', amplifyInformationComponent)

.name;

export default amplifyInformationModule;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/components/amplifyInformation/amplifyInformation.js